import feature from "../../assets/images/feature.jpg";
import {
  CheckIcon,
  CircleStackIcon,
  LockClosedIcon,
  PlusIcon,
} from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";

const Features = () => {
  return (
    <section id="features" className="py-20">
      <div className="container">
        <div className="grid lg:grid-cols-2 items-center gap-6">
          <div className="flex items-center">
            <img
              src={feature}
              className="h-[650px] rounded-xl mx-auto"
              alt="feature section"
              width={433}
              height={650}
            />
          </div>
          <div className="lg:ms-5 ms-8">
            <span className="text-sm text-primary uppercase font-semibold tracking-wider text-default-950">
              Choosing the right CRM can make or break an agent’s success. At
              Asureis, we stand out because we are built by agents, for agents.
              We understand the real challenges of selling ACA health insurance.
            </span>
            <h2 className="text-3xl md:text-4xl/tight font-semibold text-black mt-4">
              Why us?
            </h2>
            <Link
              to="#"
              className="inline-flex items-center justify-center gap-3 text-sm font-medium text-black mt-6"
            >
              Learn More
              <PlusIcon />
            </Link>
            <hr className="border-gray-200 my-6" />
            <div className="flex items-start gap-5">
              <div>
                <div className="w-12 h-12 rounded-full border border-dashed border-primary/40 bg-primary/10 flex items-center justify-center">
                  <CheckIcon className="text-base text-blue-600" />
                </div>
              </div>
              <div>
                <h4 className="text-xl font-semibold">
                  Industry-Specific Design
                </h4>
                <p className="text-base font-normal text-gray-500 mt-2">
                  Unlike generic CRMs, Asureis is tailored specifically for ACA
                  health insurance sales.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-5 mt-8">
              <div>
                <div className="w-12 h-12 rounded-full border border-dashed border-primary/40 bg-primary/10 flex items-center justify-center">
                  <CircleStackIcon className="text-base text-blue-600" />
                </div>
              </div>
              <div>
                <h4 className="text-xl font-semibold">
                  Commission & Policy Tracking
                </h4>
                <p className="text-base font-normal text-gray-500 mt-2">
                  Stay on top of every policy and unpaid commission to ensure
                  you get paid what you’re owed.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-5 mt-8">
              <div>
                <div className="w-12 h-12 rounded-full border border-dashed border-primary/40 bg-primary/10 flex items-center justify-center">
                  <LockClosedIcon className="text-base text-blue-600" />
                </div>
              </div>
              <div>
                <h4 className="text-xl font-semibold">
                  Automation That Works for You
                </h4>
                <p className="text-base font-normal text-gray-500 mt-2">
                  Reduce manual tasks and spend more time selling.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-5 mt-8">
              <div>
                <div className="w-12 h-12 rounded-full border border-dashed border-primary/40 bg-primary/10 flex items-center justify-center">
                  <LockClosedIcon className="text-base text-blue-600" />
                </div>
              </div>
              <div>
                <h4 className="text-xl font-semibold">
                  Seamless Integrations with Zapier
                </h4>
                <p className="text-base font-normal text-gray-500 mt-2">
                  Connect with your favorite tools to streamline your workflow.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-5 mt-8">
              <div>
                <div className="w-12 h-12 rounded-full border border-dashed border-primary/40 bg-primary/10 flex items-center justify-center">
                  <LockClosedIcon className="text-base text-blue-600" />
                </div>
              </div>
              <div>
                <h4 className="text-xl font-semibold">Compliance Made Easy</h4>
                <p className="text-base font-normal text-gray-500 mt-2">
                  Built-in tools help agents stay compliant without extra
                  hassle.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-5 mt-8">
              <div>
                <div className="w-12 h-12 rounded-full border border-dashed border-primary/40 bg-primary/10 flex items-center justify-center">
                  <LockClosedIcon className="text-base text-blue-600" />
                </div>
              </div>
              <div>
                <h4 className="text-xl font-semibold">Actionable Insights</h4>
                <p className="text-base font-normal text-gray-500 mt-2">
                  Get real-time data on leads, policies, and commissions to
                  optimize your sales strategy.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
